import { useMemo, useState } from 'react';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import { PiCaretDown, PiCaretUp } from 'react-icons/pi';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import { stackedFieldScopeClassName } from 'src/modules/shared/styles/stacked-field.styles';

interface DetailsSectionRevealProps {
  items: React.ReactNode[];
  initiallyVisible?: number;
}

export const DetailsSectionReveal: React.FC<DetailsSectionRevealProps> = ({
  items,
  initiallyVisible = 4,
}) => {
  const { t } = useI18n();
  const [expanded, setExpanded] = useState(false);

  const visibleItems = useMemo(() => {
    return expanded ? items : items.slice(0, initiallyVisible);
  }, [expanded, items, initiallyVisible]);

  const hiddenCount = Math.max(0, items.length - initiallyVisible);
  const showToggle = hiddenCount > 0;

  return (
    <div className="pb-3">
      <div className={stackedFieldScopeClassName}>
        {visibleItems.map((item, index) => (
          <div key={index} className="py-1.5 first:pt-0 last:pb-0">
            {item}
          </div>
        ))}
      </div>

      {showToggle && (
        <div className="mt-5 flex justify-center">
          <Button
            onClick={() => setExpanded((current) => !current)}
            size="xs"
            variant="neutral"
            appearance="soft"
            className="rounded-full"
          >
            {expanded ? (
              <>
                <PiCaretUp className="h-4 w-4" />
                <Text size="tiny">
                  {t('shared.expandableSection.viewLess')}
                </Text>
              </>
            ) : (
              <>
                <PiCaretDown className="h-4 w-4" />
                <Text size="tiny">
                  {t('communications.contactPanel.section.viewMoreCount', {
                    count: hiddenCount,
                  })}
                </Text>
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
};
